module.exports = __webpack_public_path__ + "static/media/EG.c02272de.webp";